import api from '@/api/bosheet'

const state = function () {
  return {
    all: [],
    allAvailable: false,
    full: {
      observa4: {
        available: 0,
        list: []
      },
      bactADI: {
        available: 0,
        list: []
      },
      expADI: {
        available: 0,
        list: []
      },
      reaBactADI: {
        available: 0,
        list: []
      },
      reaInfADI: {
        available: 0,
        list: []
      },
      neoInfADI: {
        available: 0,
        list: []
      },
      diaInfADI: {
        available: 0,
        list: []
      },
      badiCause: {
        available: 0,
        list: []
      },
      spy4: {
        available: 0,
        list: []
      }
    },
    export: {
      observa4: {
        available: 0,
        list: []
      },
      bactADI: {
        available: 0,
        list: []
      },
      expADI: {
        available: 0,
        list: []
      },
      reaBactADI: {
        available: 0,
        list: []
      },
      reaInfADI: {
        available: 0,
        list: []
      },
      neoInfADI: {
        available: 0,
        list: []
      },
      diaInfADI: {
        available: 0,
        list: []
      },
      badiCause: {
        available: 0,
        list: []
      },
      spy4: {
        available: 0,
        list: []
      }
    }
  }
}

// getters
const getters = {
}

// actions
const actions = {
  all ({ commit }, request) {
    return api.all(request).then((response) => {
      commit('setAll', response.data.v)
      return response
    })
  },

  insert ({ commit }, request) {
    return api.insert(request)
  },

  full ({ commit }, request) {
    return api.full(request).then(
      r => {
        if (r.data.r == null) {
          commit('setFull', { mod: request.t, year: request.y, val: r.data.v })
        }
        return r
      }
    )
  },

  export ({ commit }, request) {
    return api.export(request).then(
      r => {
        if (r.data.r == null) {
          commit('setExport', { t: request.t, d: request.d, y: request.y, e: request.e, val: r.data.v })
        }
        return r
      }
    )
  },

  summary ({ commit }, request) {
    return api.summary(request)
  }
}

// mutations
const mutations = {
  setAll (state, all) {
    state.all = Object.freeze(all)
    state.allAvailable = true
  },

  setFull (state, data) {
    state.full[data.mod].available = data.year
    const sorted = data.val.sort((f, s) => f.sv.localeCompare(s.sv))
    state.full[data.mod].list = Object.freeze(sorted)
  },

  setExport (state, data) {
    state.export[data.t].available = data.y
    const sorted = data.val.sort((f, s) => f.sv.localeCompare(s.sv))
    state.export[data.t].list = Object.freeze(sorted)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
